import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

const Breadcrumbs = ({ floor }) => {
  const history = useHistory();

  const handleGoBack = (e) => {
    e.preventDefault();
    e.stopPropagation();
    history.goBack();
  };

  return (
    <Row>
      <Col sm={12}>
        <div className="page-header-title">
          <h5>VTS Monitor</h5>
        </div>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">
                <i className="feather icon-home"></i>
              </Link>
            </li>
            {floor.map((item, index) => (
              <li className="breadcrumb-item" key={index}>
                <Link
                  onClick={item.href === 'goBack' ? handleGoBack : null}
                  to={
                    item.href
                      ? item.href === 'goBack' || item.href === 'null'
                        ? '#!'
                        : item.href
                      : ''
                  }
                >
                  <span
                    style={
                      item.style
                        ? item.style
                        : { fontStyle: 'italic', color: 'gray' }
                    }
                  >
                    {item.name}
                  </span>
                </Link>
              </li>
            ))}
          </ol>
        </nav>
      </Col>
    </Row>
  );
};

export default Breadcrumbs;
